import React, { useState, useEffect } from "react";
import { Configurations } from "../../Utils/Configurations";
//import './Cile-Content.scss';
import axios from "axios";
import ImagemFukyo from "../../Components/Imagem-Fukyo/Imagem-Fukyo";
import { withRouter } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

const Banners = ({ history }) => {

    const [banners, setBanners] = useState([])
    const [loading, setLoading] = useState(true)
    const [modalExcluir, setModalExcluir] = useState(false)
    const [loadingExcluir, setLoadingExcluir] = useState(false)
    const [itemExcluir, setItemExcluir] = useState()

    useEffect(() => {
        chamadaBanners()
    }, [])

    const chamadaBanners = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/destaques/banners`)
            .then(response => {
                setBanners(response.data.bannersDestaques)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const alteraPosicao = (idItem, direcao) => {
        const _body = {
            direcao: direcao,
            idItem: idItem
        }

        const config = new Configurations();
        axios.post(config.apiBasePath + `/destaques/banners/ordem`, _body)
            .then(() => {
                chamadaBanners()
            })
            .catch(err => {
                console.log("ERROR: ", err)
            })
            .finally(chamadaBanners())
    }


    const adicionarBanner = (_idResposta) => {
        history.push(`banners/novo-banner`)
    }

    const editBanner = (item) => {
        history.push({
            pathname: `banners/detalhes/${item._id}`,
            state: { item }
        });
    };

    const toggleModalExcluir = (id) => {
        setModalExcluir(!modalExcluir)
        setItemExcluir(id)
    }

    const toggleVisivel = (item) => {
        const _body = {
            "ativo": !item.ativo,
            "idItem": item.idItem,
            "imageDesk": item.imageDesk,
            "imageMobile": item.imageMobile,
            "link": item.link
        };

        const config = new Configurations();
        axios.put(config.apiBasePath + `/destaques/banners`, _body)
            .then(() => {
                chamadaBanners()
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
            });
    }

    const deleteBanner = (idBanner) => {
        const config = new Configurations();
        setLoadingExcluir(true)
        axios.delete(config.apiBasePath + `/destaques/banners/${idBanner}`)
            .then(() => {
                chamadaBanners()
                setLoadingExcluir(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setModalExcluir(false)
            });
    }


    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">Banners</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                            <button className="btn btn-outline-primary" type="button" onClick={() => adicionarBanner(10)}>
                                incluir banner
                            </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="no-gutters align-items-center py-lg-4 px-lg-3">


                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <div className="lista-conteudo">
                            {(banners).map((item, indice) => {
                                return (
                                    <div className="col-lg-10 col-12 pt-2 mt-3 offset-lg-1 offset-0 content-product " key={indice} >
                                        <div className="row no-gutters">
                                            <div className="col-12">
                                                <div className="card bg-white">
                                                    <div className={`${item.ativo ? 'bg-purple' : 'bg-secondary'} text-white card-header`}>
                                                        <div className="row no-gutters">
                                                            <div className="col-12 pb-3 pb-lg-0">
                                                                <div className="row no-gutters">
                                                                    <div className="col-4 border-white">
                                                                        <span className="tipo-label d-flex align-items-center">
                                                                            Carrossel
                                                                        </span>

                                                                    </div>
                                                                    <React.Fragment>
                                                                        <div className="col-4 d-none d-md-block text-center">
                                                                            <button className="btn btn-outline-light" type="button" onClick={() => editBanner(item)} >
                                                                                Editar banner
                                                                            </button>
                                                                        </div>
                                                                        <div className="col-8 col-md-4 text-right border-white d-flex justify-content-end align-items-center">


                                                                            {banners &&
                                                                                <React.Fragment>
                                                                                    <i className={'cursor-pointer fas fa-arrow-up icones-destaques-ativos px-3 ' + (indice === 0 ? 'd-none' : null)} onClick={() => alteraPosicao(item.idItem, -1)} ></i>
                                                                                    <i className={'cursor-pointer fas fa-arrow-down icones-destaques-ativos px-3 ' + (indice === (banners.length - 1) ? 'd-none' : null)} onClick={() => alteraPosicao(item.idItem, 1)} ></i>
                                                                                </React.Fragment>}


                                                                                <i className={`far fa-eye-slash icones-destaques-ativos cursor-pointer`} onClick={() => toggleVisivel(item)}></i>


                                                                            <span className={`${item.ativo ? 'text-purple' : 'text-secondary'} mx-3 badge bg-white`}>{item.ativo ? 'Disponível' : 'Indisponível'}</span>

                                                                            <i className="far fa-trash-alt ml-1 mr-1 cursor-pointer" onClick={() => toggleModalExcluir(item._id)}></i>

                                                                        </div>
                                                                    </React.Fragment>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={`card-body pt-3`}>
                                                        <div className="card-body pt-3">
                                                            <div className="row no-gutters">
                                                                <div className="col-3 d-lg-block d-none">
                                                                    <ImagemFukyo
                                                                        className={`img img-fluid`}
                                                                        src={item.imageDesk}
                                                                        alt={`imagem-destaque`}
                                                                    />

                                                                </div>
                                                                <div className="col-lg-9 col-12  px-lg-4 px-0" >
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <p className="infos-ativos"><strong>Redirecionar para:</strong> <a href={item.link} target="_blank" rel="noopener noreferrer">{item.link}</a> </p>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    }
                </div>
            </div>

            <Modal isOpen={modalExcluir} toggle={toggleModalExcluir} >
                <ModalHeader toggle={toggleModalExcluir}>Remover conteúdo</ModalHeader>
                <ModalBody>
                    <p className="m-0">{`Deseja excluir esse item da lista de conteúdos?`}</p>
                </ModalBody>
                <ModalFooter>
                    {loadingExcluir ? (
                        <div className="spinner-border spinner-border-sm text-danger" role="status" />
                    ) : (
                        <Button disabled={loadingExcluir} color={`danger`} onClick={() => deleteBanner(itemExcluir)}>Excluir</Button>
                    )}
                    {' '}<Button color="secondary" onClick={toggleModalExcluir}>cancelar</Button>
                </ModalFooter>
            </Modal>


        </div>
    )
}


export default withRouter(Banners);